import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "form-list-wrapper" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-head pb-3" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "row align-items-center" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "title mb-0" }
const _hoisted_8 = {
  class: "table-responsive my-3",
  id: "filteredGuestUsers"
}
const _hoisted_9 = { class: "table table-shadowed mb-0 table-bordered" }
const _hoisted_10 = { class: "table-primary text-nowrap" }
const _hoisted_11 = { scope: "col" }
const _hoisted_12 = { scope: "col" }
const _hoisted_13 = { scope: "col" }
const _hoisted_14 = { scope: "col" }
const _hoisted_15 = { scope: "col" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "badge badge-success to-upper" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "badge badge-danger" }
const _hoisted_22 = { class: "table-button" }
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "fa fa-stop-circle to-upper" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "fa fa-stop-circle" }, null, -1)
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { colspan: 5 }
const _hoisted_27 = { class: "text-danger text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('manage_project_tags')), 1)
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t('project_tags')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("table", _hoisted_9, [
              _createVNode("thead", _hoisted_10, [
                _createVNode("tr", null, [
                  _createVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('tag_name')), 1),
                  _createVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('status')), 1),
                  _createVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('created_date')), 1),
                  _createVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('created_by')), 1),
                  _createVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('action')), 1)
                ])
              ]),
              (_ctx.state.data.projectTagList && _ctx.state.data.projectTagList.length)
                ? (_openBlock(), _createBlock("tbody", _hoisted_16, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectTagList, (tag, formIndex) => {
                      return (_openBlock(), _createBlock("tr", { key: formIndex }, [
                        _createVNode("td", null, [
                          (tag.name)
                            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                                _createVNode("h5", null, _toDisplayString(tag.name), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("td", null, [
                          (tag.is_active && tag.is_active === 1)
                            ? (_openBlock(), _createBlock("p", _hoisted_18, [
                                _createVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('enable')), 1)
                              ]))
                            : (_openBlock(), _createBlock("p", _hoisted_20, [
                                _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('disable')), 1)
                              ]))
                        ]),
                        _createVNode("td", null, [
                          _createVNode("p", null, _toDisplayString(tag.created), 1)
                        ]),
                        _createVNode("td", null, [
                          _createVNode("p", null, _toDisplayString(tag.user.full_name), 1)
                        ]),
                        _createVNode("td", null, [
                          _createVNode("div", _hoisted_22, [
                            (tag.is_active  != 1)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  href: "javascript:void(0)",
                                  class: "btn enable-btn mr-1",
                                  onClick: ($event: any) => (_ctx.enableTag(tag))
                                }, [
                                  _hoisted_23,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('enable')), 1)
                                ], 8, ["onClick"]))
                              : (_openBlock(), _createBlock("a", {
                                  key: 1,
                                  href: "javascript:void(0)",
                                  class: "btn delete-btn mr-1",
                                  onClick: ($event: any) => (_ctx.enableTag(tag))
                                }, [
                                  _hoisted_24,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('disable')), 1)
                                ], 8, ["onClick"]))
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock("tfoot", _hoisted_25, [
                    _createVNode("tr", null, [
                      _createVNode("td", _hoisted_26, [
                        _createVNode("p", _hoisted_27, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('no_tags_found')), 1)
                        ])
                      ])
                    ])
                  ]))
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}